import { SectionTitleWithDesc } from 'views/common/components';
import { styled } from '@mui/material/styles';

const StyledFranchiseTitleWithDesc = styled(SectionTitleWithDesc)(
  ({ theme }) => ({
    '&.overview .title': {
      marginBottom: theme.spacing(2),
    },
    '& .title': {
      color: theme.palette.secondary.main,
    },
    '& .desc': {
      color: theme.palette.secondary.main,
      '& a': {
        textDecoration: 'none',
      },
    },
    '& p:not(.MuiTypography-root),& ul': {
      margin: 0,
    },
  }),
);

export { StyledFranchiseTitleWithDesc };
